import { render, staticRenderFns } from "./CompanyCompass.vue?vue&type=template&id=2aebc06f&scoped=true&"
import script from "./CompanyCompass.vue?vue&type=script&lang=ts&"
export * from "./CompanyCompass.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyCompass.vue?vue&type=style&index=0&id=2aebc06f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aebc06f",
  null
  
)

export default component.exports